import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Space, Tag } from 'tdesign-react';
import SvgIcon from '@/components/SvgIcon';
import ShadowCard from '@/components/ShadowCard';
import PermWrapper from '@/components/PermWrapper';
import LinkClusterModal from '../../ClusterList/LinkClusterModal';
import InfoPanel from './InfoPanel';

function BasicInfo({ detail, doRefresh }) {
  const [visible, setVisible] = useState(false);

  const handleClose = (refresh) => {
    setVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  return (
    <Root>
      <Title>
        <Space align='center' size='small'>
          {detail.clusterType === 'kop' ? (
            <Tag theme='primary' variant='light'>
              KOP
            </Tag>
          ) : (
            <Tag theme='success' variant='light'>
              KAFKA
            </Tag>
          )}

          {detail.displayName}
          <PermWrapper resource='kop:cluster:update'>
            <Icon onClick={() => setVisible(true)} type='pencil-alt' />
          </PermWrapper>
        </Space>
      </Title>
      <InfoPanel />
      <LinkClusterModal
        visible={visible}
        handleClose={handleClose}
        clusterName={detail.clusterName}
      />
    </Root>
  );
}

export default connect((state) => ({
  detail: state.kopCluster.detail,
}))(BasicInfo);

const Root = styled(ShadowCard)`
  padding-bottom: 10px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #0d111a;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .t-space-item {
    display: flex;
    align-items: center;
  }
`;

const Icon = styled(SvgIcon)`
  color: var(--td-font-gray-2);
  cursor: pointer;
`;
